import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1;

const NameIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 20;

	if (size) {
		height = size;
	}

	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.84893 10.5809C11.0282 10.5809 11.984 9.62484 11.984 8.44573C11.984 7.2665 11.0282 6.31055 9.84893 6.31055C8.66957 6.31055 7.71375 7.2665 7.71375 8.44573C7.71516 9.62432 8.67022 10.5794 9.84893 10.5809ZM9.84893 7.14067C10.5719 7.14067 11.158 7.72673 11.158 8.44986C11.158 9.17286 10.5719 9.75906 9.84893 9.75906C9.1258 9.75906 8.53974 9.17286 8.53974 8.44986C8.53987 7.72686 9.12593 7.14093 9.84893 7.14067Z"
				fill={color}
			/>
			<path
				d="M9.84887 11.3702C8.97526 11.3638 8.13689 11.7144 7.52785 12.3407C6.90836 12.9726 6.5697 13.8317 6.5697 14.765C6.57035 14.9928 6.75478 15.1774 6.9827 15.178H12.7149C12.9428 15.1774 13.1273 14.9928 13.1279 14.765C13.1279 13.8317 12.7893 12.9726 12.1698 12.3407C11.5609 11.7144 10.7224 11.3638 9.84887 11.3702ZM7.4246 14.352C7.4952 13.812 7.73873 13.3095 8.11843 12.9189C8.57543 12.4565 9.19867 12.1962 9.84887 12.1962C10.499 12.1962 11.1222 12.4565 11.5792 12.9189C11.9581 13.3099 12.2014 13.8123 12.273 14.352H7.4246Z"
				fill={color}
			/>
			<path
				d="M14.9412 1H5.05882C3.92197 1.0005 3.00039 1.88773 3 2.98238V17.0176C3.00039 18.1123 3.92197 18.9995 5.05882 19H14.9412C16.078 18.9995 16.9995 18.1123 17 17.0176V2.98238C16.9995 1.88773 16.078 1.0005 14.9412 1ZM16.1765 17.0176C16.1745 17.6737 15.6225 18.2052 14.9412 18.207H5.05882C4.37748 18.2052 3.82546 17.6737 3.82353 17.0176V2.98238C3.82546 2.32634 4.37748 1.79481 5.05882 1.79295H14.9412C15.6225 1.79481 16.1745 2.32634 16.1765 2.98238V17.0176Z"
				fill={color}
			/>
			<path
				d="M8.12674 3.39923H11.4307C11.6587 3.39923 11.8437 3.21429 11.8437 2.98624C11.8437 2.75819 11.6587 2.57324 11.4307 2.57324H8.12674C7.89856 2.57324 7.71375 2.75819 7.71375 2.98624C7.71375 3.21429 7.89856 3.39923 8.12674 3.39923Z"
				fill={color}
			/>
		</svg>
	);
};

export default NameIcon;
